import { Component, Input } from '@angular/core';
import { CalendarEvent } from 'src/app/shared/model/common.model';

@Component({
  selector: 'app-add-to-calendar',
  templateUrl: './add-to-calendar.component.html',
  styleUrls: ['./add-to-calendar.component.scss']
})
export class AddToCalendarComponent {
  @Input() event!: CalendarEvent;
  @Input() multi:boolean = false;
  @Input() isOpen!: boolean;

  closeDropdown() {
    this.isOpen = false;
  }

  get addToGoogleCalendar() {
    return this.buildGoogleUrl();
    //window.open(url, '_blank');
  }

  get addToYahooCalendar() {
    return this.buildYahooUrl();
    // window.open(url, '_blank');
  }

  downloadICS(): void {
    const ics = this.buildICS();
    const blob = new Blob([ics], {
      type: 'text/calendar;charset=utf-8'
    });

    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = 'event.ics';
    link.click();

    URL.revokeObjectURL(url);
  }

  // ----------------------
  // Google Calendar
  // ----------------------
  private buildGoogleUrl(): string {
    const start = this.formatGoogleDate(this.event.start);
    const end = this.formatGoogleDate(this.event.end);

    const params = new URLSearchParams({
      action: 'TEMPLATE',
      text: this.event.title,
      dates: `${start}/${end}`,
      details: this.event.description || '',
      location: this.event.location || ''
    });

    return `https://calendar.google.com/calendar/render?${params.toString()}`;
  }

  // ----------------------
  // Yahoo Calendar
  // ----------------------
  private buildYahooUrl(): string {
    const start = this.formatYahooDate(this.event.start);
    const end = this.formatYahooDate(this.event.end);

    const params = new URLSearchParams({
      v: '60',
      title: this.event.title,
      st: start,
      et: end,
      desc: this.event.description || '',
      in_loc: this.event.location || ''
    });

    return `https://calendar.yahoo.com/?${params.toString()}`;
  }
  // ----------------------
  // Outlook web Calendar
  // ----------------------
  addToOutlookWeb(): void {
    window.open(this.buildOutlookWebUrl(), '_blank');
  }

  private buildOutlookWebUrl(): string {
    const start = this.event.start.toISOString();
    const end = this.event.end.toISOString();

    const params = new URLSearchParams({
      subject: this.event.title,
      body: this.event.description || '',
      location: this.event.location || '',
      startdt: start,
      enddt: end
    });

    return `https://outlook.office365.com/calendar/0/deeplink/compose?${params.toString()}`;
  }



  // ----------------------
  // ICS (Apple, Outlook, Teams)
  // ----------------------
  private buildICS(): string {
    const start = this.formatICSDate(this.event.start);
    const end = this.formatICSDate(this.event.end);
    const now = this.formatICSDate(new Date());

    return `BEGIN:VCALENDAR
VERSION:2.0
CALSCALE:GREGORIAN
PRODID:-//Add To Calendar//EN
METHOD:PUBLISH
BEGIN:VEVENT
UID:${Date.now()}@add-to-calendar
DTSTAMP:${now}
DTSTART:${start}
DTEND:${end}
SUMMARY:${this.escape(this.event.title)}
DESCRIPTION:${this.escape(this.event.description || '')}
LOCATION:${this.escape(this.event.location || '')}
END:VEVENT
END:VCALENDAR`;
  }

  // ----------------------
  // Date helpers
  // ----------------------
  private formatGoogleDate(date: Date): string {
    return date.toISOString().replace(/[-:]/g, '').split('.')[0] + 'Z';
  }

  private formatYahooDate(date: Date): string {
    const local = new Date(
      date.getTime() - date.getTimezoneOffset() * 60000
    );
    return local.toISOString().replace(/[-:]/g, '').split('.')[0];

  }

  private formatICSDate(date: Date): string {
    return date.toISOString().replace(/[-:]/g, '').split('.')[0] + 'Z';
  }

  private escape(value: string): string {
    return value
      .replace(/\\/g, '\\\\')
      .replace(/;/g, '\\;')
      .replace(/,/g, '\\,')
      .replace(/\n/g, '\\n');
  }
}
